var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesEmailTracking = function SvgYeswareSalesEmailTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 25.192,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.636 35.246a.943.943 0 0 0-1.445-.8L44.497 46.058a8.526 8.526 0 0 1-8.993 0L18.806 34.446a.932.932 0 0 0-.954-.026.94.94 0 0 0-.487.826v15.992a5.659 5.659 0 0 0 5.659 5.659h33.953a5.659 5.659 0 0 0 5.659-5.66v-15.99Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.636 28.762a5.66 5.66 0 0 0-5.66-5.659H23.025a5.659 5.659 0 0 0-5.659 5.66.275.275 0 0 0 .132.237l20.994 14.305a2.837 2.837 0 0 0 2.996 0L62.492 29a.283.283 0 0 0 .144-.238Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareSalesEmailTracking;